import apiCall from "../../axios";

interface TuringSpeakerDeviceDto {
  id: number;
  camera_id: number;
  box_id: string;
  device_type: string;
}

interface GetSpeakersForCameraPayload {
  cameraUsername: string;
  token: string;
}

interface GetSpeakersForCameraResponse {
  success: boolean;
  speakers: TuringSpeakerDeviceDto[];
  message?: string;
  error?: string;
}

/**
 * Fetches the list of Turing Speaker devices associated with a specific camera.
 */
const getSpeakersForCamera = async (
  body: GetSpeakersForCameraPayload
): Promise<GetSpeakersForCameraResponse> => {
  try {
    const response = await apiCall("POST", `/turingcloud/camera/speakers`, body);

    // Backend returns nested structure: { success: true, data: { success: true, speakers: [...] } }
    // Extract the speakers from the nested data
    if (response.data?.data?.speakers) {
      return {
        success: true,
        speakers: response.data.data.speakers
      };
    }

    // Fallback for direct response structure
    return {
      success: response.data?.success || false,
      speakers: response.data?.speakers || [],
      error: response.data?.error
    };
  } catch (error: any) {
    console.error("getSpeakersForCamera Error:", error);
    return {
      success: false,
      speakers: [],
      error: error.message || "An unexpected error occurred while fetching speakers."
    };
  }
};

export default getSpeakersForCamera;
export type { TuringSpeakerDeviceDto, GetSpeakersForCameraPayload, GetSpeakersForCameraResponse };